import React from "react";

import SkipNextIcon from "@mui/icons-material/SkipNext";
import { LoadingButton, LoadingButtonProps } from "@mui/lab";

export const NextButton = (props: LoadingButtonProps) => {
  console.log(props)
  
  return (
    <LoadingButton type="submit" loadingPosition="start" startIcon={<SkipNextIcon />} variant="contained" {...props}>
     {props.isFrenchLanguage?"Suivant":"Next"} 
     
    </LoadingButton>
  );
};
